import { RouterResolver } from '@isaia/router';

export const resolveMaintenanceRoutes = (resolver: RouterResolver) => {
  return resolver.createFeatureResolver('maintenance', (rootPath) => {
    return {};
  });
};
